import React, { useState } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import Navbar from "./Components/Navbar";

const { Content } = Layout;

const AdminLayout = () => {
  const isSmallScreen = window.innerWidth < 1025;
  const [collapsed, setCollapsed] = useState(isSmallScreen);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 200,
          transition: "margin-left 0.2s",
        }}
      >
        <Content
          style={{
            background: "#fff",
            minHeight: "100vh",
            padding: "24px 32px",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
